var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 46,
    viewBox: "0 0 23 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.038 32.9318C20.3339 33.159 20.5158 33.5115 20.5158 33.9352V39.6039C20.5158 39.9798 20.3673 40.3303 20.0774 40.5747C20.0086 40.6329 19.94 40.6802 19.8716 40.7188L19.8712 40.7379C19.8634 41.099 19.798 41.4536 19.6754 41.793C18.6024 44.7534 13.8238 45.4433 11.1324 45.4489C8.43683 45.4542 3.67775 44.7848 2.58028 41.8346C2.44926 41.4813 2.38027 41.1123 2.37331 40.7371L2.37271 40.7119C1.98561 40.5041 1.72894 40.1224 1.72894 39.604V33.9354C1.72894 33.5393 1.89356 33.1731 2.2065 32.9312L1.87726 17.5141L0.447168 17.8972L0.146357 17.0327C-0.276527 15.8182 0.248748 15.0245 1.31302 14.6159C1.28399 14.506 1.26828 14.3883 1.26828 14.2638V8.59494C1.26828 8.19095 1.42137 7.87443 1.66651 7.65712L1.6514 6.95033C1.63888 6.35209 1.89654 5.71528 2.18403 5.1733C2.26137 4.35159 2.88645 3.41655 3.3318 2.83959C3.82964 2.19383 4.68893 1.22897 5.6019 1.08602C6.12777 0.688385 6.75921 0.333496 7.41014 0.333496H14.8344C15.4891 0.333496 16.1241 0.692759 16.6512 1.09298C17.5486 1.24865 18.4123 2.19462 18.9117 2.83223C19.3726 3.42013 19.9869 4.35 20.0597 5.17231C20.347 5.71468 20.6058 6.35209 20.5933 6.95053L20.578 7.65732C20.8233 7.87463 20.976 8.19115 20.976 8.59514V14.264C20.976 14.3835 20.9611 14.5002 20.9315 14.6115C21.3615 14.7746 21.7538 15.0126 22.0087 15.4261C22.3 15.8989 22.3033 16.4436 22.1248 16.9574L21.7975 17.8974L20.3676 17.5143L20.038 32.9318Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.872 33.0146C20.1676 33.2089 20.3511 33.5337 20.3511 33.9349V39.6036C20.3511 39.9309 20.2241 40.2362 19.972 40.449C19.8841 40.5227 19.797 40.5768 19.7095 40.6164L19.7072 40.7341C19.6998 41.0774 19.6376 41.4144 19.5207 41.7367C18.4779 44.614 13.7408 45.2786 11.132 45.2842C8.51872 45.2896 3.80099 44.6446 2.73433 41.7771C2.60928 41.4413 2.54406 41.0902 2.5373 40.7337L2.53472 40.6082C2.15299 40.44 1.89294 40.0957 1.89294 39.6036V33.9349C1.89294 33.5735 2.04762 33.2415 2.34624 33.0317C2.35519 33.0255 2.36374 33.0196 2.37249 33.0138L2.03688 17.3009L0.551917 17.6985L0.301407 16.9782C-0.110741 15.7941 0.44038 15.0755 1.51996 14.7155C1.46349 14.5809 1.43268 14.4296 1.43268 14.2634V8.59469C1.43268 8.20998 1.58795 7.9205 1.8325 7.73282L1.8158 6.9467C1.80327 6.36993 2.06472 5.74346 2.34425 5.22096C2.4031 4.43067 3.03773 3.48927 3.4618 2.93934C3.92962 2.33255 4.78811 1.35417 5.66649 1.24283C6.17009 0.85673 6.78682 0.49707 7.41031 0.49707H14.8345C15.4612 0.49707 16.0805 0.860111 16.5849 1.2478C17.448 1.37226 18.3117 2.33175 18.7829 2.93318C19.2234 3.49503 19.8457 4.42848 19.8992 5.21937C20.1791 5.74226 20.4416 6.36933 20.4293 6.9467L20.4124 7.73282C20.6569 7.9205 20.812 8.20998 20.812 8.59469V14.2636C20.812 14.4208 20.7829 14.5727 20.7251 14.7113C21.1794 14.8636 21.608 15.0881 21.8691 15.5115C22.1343 15.9418 22.1319 16.4362 21.9701 16.9029L21.6927 17.6987L20.208 17.3011L19.872 33.0146Z",
    fill: "#E9E8E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7059 33.1067C20.0008 33.2636 20.1873 33.5576 20.1873 33.935V39.6036C20.1873 39.8824 20.0817 40.1418 19.8664 40.3232C19.7608 40.412 19.6554 40.4677 19.5479 40.5021L19.5429 40.7303C19.5361 41.0558 19.4773 41.3749 19.3664 41.6809C18.8735 43.0412 17.476 43.8544 16.1861 44.322C14.6128 44.8924 12.799 45.1164 11.1316 45.12C9.46666 45.1232 7.65583 44.9077 6.08299 44.3454C4.78988 43.8828 3.3924 43.0758 2.8882 41.7195C2.76951 41.4009 2.70767 41.0687 2.70151 40.7299L2.69674 40.4949C2.32097 40.3695 2.05754 40.0675 2.05754 39.6034V33.9348C2.05754 33.6268 2.18598 33.3449 2.44086 33.1655C2.47367 33.1431 2.50607 33.1224 2.53868 33.1049L2.19651 17.0882L0.656875 17.5005L0.456467 16.9244C0.308944 16.5003 0.260632 16.0496 0.484102 15.641C0.729641 15.1919 1.20183 14.9823 1.66846 14.8406C1.69907 14.831 1.72969 14.8221 1.76091 14.8131C1.65673 14.6644 1.59708 14.4787 1.59708 14.2632V8.59473C1.59708 8.2307 1.75534 7.97164 1.99869 7.81636L1.9798 6.94316C1.96807 6.38806 2.23409 5.77033 2.50567 5.26772C2.54285 4.51361 3.19 3.56088 3.59201 3.03958C4.02802 2.47434 4.89088 1.47628 5.73029 1.40133C6.21083 1.02716 6.81464 0.661133 7.41049 0.661133H14.8347C15.4304 0.661133 16.0338 1.02696 16.5137 1.40033C17.013 1.44487 17.4871 1.81944 17.8351 2.14292C18.1244 2.41211 18.4095 2.72267 18.6534 3.03421C19.0725 3.56903 19.7053 4.51003 19.7378 5.26534C20.0099 5.76835 20.2769 6.38726 20.2652 6.94296L20.2461 7.81616C20.4895 7.97184 20.6479 8.2307 20.6479 8.59453V14.2634C20.6479 14.4622 20.5941 14.6509 20.4863 14.8082C20.9706 14.9493 21.4573 15.1565 21.7293 15.5977C21.9681 15.9852 21.9605 16.4295 21.8146 16.8488L21.5877 17.5007L20.0483 17.0884L19.7059 33.1067Z",
    fill: "#DDE0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5395 33.2112C19.8335 33.3253 20.023 33.5832 20.023 33.9355V39.6042C20.023 39.8344 19.9385 40.0483 19.7602 40.1982C19.6397 40.3 19.5156 40.3497 19.3862 40.3738L19.3788 40.7275C19.3721 41.035 19.3166 41.3365 19.212 41.6253C18.7371 42.9351 17.37 43.7191 16.13 44.1684C14.575 44.7325 12.7791 44.9533 11.1307 44.9565C9.4855 44.9601 7.69257 44.7472 6.13802 44.1909C4.89482 43.7463 3.52735 42.9689 3.04164 41.6629C2.92971 41.3615 2.87145 41.0474 2.86529 40.7271L2.85793 40.3706C2.49072 40.2907 2.22132 40.0382 2.22132 39.6042V33.9355C2.22132 33.6816 2.32391 33.449 2.53466 33.3007C2.59132 33.2615 2.64759 33.2315 2.70465 33.2094L2.35572 16.8762L0.761209 17.3032L0.610903 16.871C0.479286 16.4931 0.427793 16.0859 0.627604 15.7205C0.849285 15.3143 1.29464 15.1262 1.71553 14.9982C1.83462 14.9618 1.95451 14.9292 2.07499 14.8978C1.88035 14.7632 1.76086 14.5468 1.76086 14.2639V8.59506C1.76086 8.25349 1.9231 8.03002 2.16426 7.91053L2.14358 6.9401C2.13185 6.40648 2.40423 5.79472 2.66747 5.31299C2.67999 4.60142 3.34325 3.63059 3.7216 3.14011C4.12321 2.61941 4.9988 1.59371 5.79088 1.5619C6.24777 1.20125 6.84143 0.825684 7.41005 0.825684H14.8343C15.4029 0.825684 15.9966 1.20125 16.4529 1.56151C16.929 1.58119 17.4 1.96331 17.7231 2.26353C18.0062 2.52636 18.2853 2.83095 18.5241 3.13574C18.9208 3.64173 19.5671 4.59625 19.5749 5.3104C19.8387 5.79253 20.1121 6.40529 20.1009 6.93971L20.0803 7.91013C20.3212 8.03002 20.4837 8.25329 20.4837 8.59466V14.2635C20.4837 14.5075 20.389 14.7317 20.1922 14.8815C20.187 14.8856 20.1811 14.8898 20.1755 14.894C20.6934 15.0268 21.2956 15.2067 21.5893 15.6839C21.802 16.0286 21.7889 16.4231 21.6597 16.7951L21.4827 17.303L19.8884 16.876L19.5395 33.2112Z",
    fill: "#D5D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3726 33.3317C19.666 33.3977 19.8589 33.6113 19.8589 33.9351V39.6038C19.8589 39.7855 19.7955 39.9537 19.6545 40.0724C19.5229 40.1836 19.377 40.2184 19.2255 40.2285L19.2145 40.7235C19.2086 41.0132 19.1561 41.2967 19.0577 41.5689C18.6016 42.8274 17.2637 43.5823 16.074 44.0138C14.5374 44.5713 12.7593 44.7884 11.1306 44.7917C9.50449 44.7953 7.72985 44.5856 6.1932 44.0358C5.00029 43.6092 3.66245 42.8604 3.19563 41.6049C3.09026 41.3214 3.03499 41.0252 3.02962 40.7229L3.01888 40.2287C2.66459 40.1969 2.38525 40.0058 2.38525 39.6034V33.9347C2.38525 33.7343 2.46219 33.5514 2.6292 33.4341C2.70793 33.379 2.78845 33.3478 2.87176 33.3305L2.51568 16.6627L0.866487 17.1047L0.766084 16.8166C0.435849 15.868 0.888556 15.4207 1.76335 15.1549C1.99994 15.0829 2.24051 15.0254 2.47929 14.9604L2.4775 14.8793C2.15244 14.8296 1.92499 14.6191 1.92499 14.2634V8.5949C1.92499 8.27798 2.09418 8.09766 2.33097 8.01813L2.30771 6.93656C2.29698 6.42382 2.5779 5.81484 2.83179 5.35557C2.8141 4.6955 3.49863 3.69823 3.85153 3.24036C4.21656 2.76757 5.11561 1.7037 5.84924 1.72557C6.28068 1.37943 6.86858 0.989746 7.41035 0.989746H14.8346C15.3768 0.989746 15.9649 1.38002 16.3953 1.72557C16.8422 1.71404 17.3164 2.10948 17.6117 2.38385C17.8884 2.64132 18.162 2.93915 18.3952 3.23737C18.7662 3.71096 19.4314 4.68914 19.411 5.35279C19.6654 5.81245 19.9478 6.42302 19.937 6.93676L19.9138 8.01833C20.1504 8.09786 20.3197 8.27838 20.3197 8.5951V14.264C20.3197 14.4564 20.2488 14.6328 20.0927 14.7513C19.9885 14.8306 19.8802 14.865 19.7668 14.8797L19.7652 14.9596C19.8658 14.9857 19.9666 15.0103 20.0672 15.0358C20.5482 15.1579 21.1721 15.3197 21.4494 15.77C21.6355 16.0718 21.6172 16.417 21.5045 16.7412L21.3777 17.1051L19.7287 16.6631L19.3726 33.3317Z",
    fill: "#CDCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2053 33.4747C19.2305 33.4759 19.2558 33.4783 19.2816 33.4821C19.5323 33.5175 19.6946 33.6696 19.6946 33.9352V39.6038C19.6946 39.7367 19.6522 39.8597 19.5488 39.9468C19.4131 40.0613 19.2361 40.0711 19.0643 40.0691L19.0506 40.7202C19.0448 40.9916 18.9959 41.258 18.9035 41.5131C18.4659 42.7199 17.1569 43.4466 16.0179 43.8597C14.4991 44.4103 12.7396 44.6246 11.1301 44.6276C9.52349 44.6311 7.76695 44.4248 6.24858 43.8818C5.10578 43.4728 3.79716 42.7521 3.34943 41.5481C3.25022 41.2817 3.19872 41.0037 3.19356 40.7202L3.17944 40.0695C3.15041 40.0703 3.12099 40.0703 3.09136 40.0691C2.79612 40.0593 2.54939 39.9391 2.54939 39.6038V33.9352C2.54939 33.7884 2.60068 33.6552 2.72375 33.569C2.81978 33.5014 2.92794 33.4813 3.03888 33.4749L2.67504 16.4506L0.971377 16.9069L0.921076 16.7627C0.623447 15.9076 1.02685 15.5506 1.81138 15.312C2.08754 15.2277 2.36886 15.1635 2.64601 15.0847L2.63826 14.7271C2.60903 14.7267 2.57921 14.7255 2.54939 14.7227C2.27979 14.6978 2.08933 14.5533 2.08933 14.2634V8.59494C2.08933 8.30586 2.26886 8.1816 2.49809 8.14482L2.47205 6.93283C2.46131 6.43996 2.75457 5.82899 2.99812 5.39418C2.94245 4.79713 3.65461 3.76487 3.98187 3.3408C4.30653 2.9195 5.24575 1.80235 5.90224 1.8942C6.30445 1.56516 6.89394 1.15381 7.41027 1.15381H14.8345C15.3514 1.15381 15.9415 1.56655 16.3429 1.8944C16.9805 1.81587 17.9327 2.91294 18.2661 3.33861C18.6116 3.77939 19.3013 4.78779 19.2445 5.3908C19.4884 5.82581 19.7835 6.43896 19.7727 6.93303L19.7469 8.14501C19.9757 8.1818 20.1554 8.30645 20.1554 8.59514V14.264C20.1554 14.4048 20.1081 14.5336 19.9938 14.6205C19.8783 14.7084 19.7431 14.7247 19.6065 14.7271L19.599 15.0849C19.7409 15.1243 19.8847 15.1589 20.0274 15.1951C20.4557 15.3038 21.0626 15.4551 21.3102 15.8565C21.4694 16.1148 21.446 16.4112 21.3499 16.6876L21.2732 16.9073L19.5695 16.451L19.2053 33.4747Z",
    fill: "#C5C5C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0377 33.6362C19.2025 33.6362 19.5306 33.6097 19.5306 33.9348V39.6035C19.5306 39.9604 19.1292 39.9021 18.9041 39.9021L18.8864 40.7165C18.78 45.6921 3.45005 45.7328 3.3578 40.7165L3.3403 39.9021C3.11504 39.9021 2.71363 39.9604 2.71363 39.6035V33.9348C2.71363 33.6097 3.04148 33.6362 3.2065 33.6362L2.83491 16.2375L1.07637 16.7085C0.82109 15.9757 1.12448 15.6923 1.85931 15.4687C2.17503 15.3727 2.49652 15.3023 2.81284 15.2068L2.79892 14.5621C2.61621 14.5621 2.25317 14.6044 2.25317 14.2635V8.59458C2.25317 8.32319 2.48678 8.29615 2.66532 8.29615L2.63629 6.92889C2.62714 6.51952 2.85936 5.9694 3.17031 5.42285L3.16852 5.42583C3.00172 4.60491 5.14238 1.79384 5.94421 2.07198L5.93844 2.07656C6.4494 1.6491 6.98442 1.31787 7.41029 1.31787H14.8345C15.2588 1.31787 15.7906 1.64632 16.2998 2.07119C16.8314 1.89086 17.8683 3.09669 18.1365 3.43925C18.4248 3.80726 19.1799 4.88485 19.0741 5.42305C19.385 5.9696 19.6171 6.52032 19.6085 6.92909L19.5793 8.29635C19.758 8.29635 19.9912 8.32359 19.9912 8.59478V14.2636C19.9912 14.6046 19.6286 14.5623 19.4455 14.5623L19.4318 15.207C20.3042 15.4705 21.5679 15.5605 21.1949 16.6332L21.1682 16.7089L19.4097 16.2379L19.0377 33.6362Z",
    fill: "#BBBDBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6388 38.6489V32.9799C17.6388 32.8156 17.7728 32.6816 17.937 32.6816H18.5313C18.6955 32.6816 18.8297 32.8156 18.8297 32.9799V38.6489C18.8297 38.8132 18.6955 38.9472 18.5313 38.9472H17.937C17.7728 38.9472 17.6388 38.8132 17.6388 38.6489ZM2.01318 38.6489V32.9799C2.01318 32.8156 2.14699 32.6816 2.31141 32.6816H2.90567C3.0699 32.6816 3.2041 32.8156 3.2041 32.9799V38.6489C3.2041 38.8132 3.0699 38.9472 2.90567 38.9472H2.31141C2.14679 38.9472 2.01318 38.8132 2.01318 38.6489Z",
    fill: "#414142"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7471 38.6495V32.9804C17.7471 32.876 17.8326 32.7905 17.9371 32.7905H18.5314C18.636 32.7905 18.7219 32.876 18.7219 32.9804V38.6495C18.7219 38.7539 18.636 38.8393 18.5314 38.8393H17.9371C17.8326 38.8393 17.7471 38.7539 17.7471 38.6495Z",
    fill: "url(#paint0_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12158 38.6504V32.9814C2.12158 32.877 2.20707 32.7915 2.31165 32.7915H2.90592C3.01049 32.7915 3.09579 32.877 3.09579 32.9814V38.6504C3.09579 38.7548 3.01049 38.8403 2.90592 38.8403H2.31165C2.20687 38.8403 2.12158 38.7548 2.12158 38.6504Z",
    fill: "url(#paint1_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0992 13.3086V7.63973C18.0992 7.47551 18.2334 7.34131 18.3976 7.34131H18.9919C19.1559 7.34131 19.2903 7.47551 19.2903 7.63973V13.3086C19.2903 13.473 19.1559 13.607 18.9919 13.607H18.3976C18.2334 13.6068 18.0992 13.473 18.0992 13.3086ZM1.55225 13.3086V7.63973C1.55225 7.47551 1.68645 7.34131 1.85087 7.34131H2.44513C2.60936 7.34131 2.74336 7.47551 2.74336 7.63973V13.3086C2.74336 13.473 2.60936 13.607 2.44513 13.607H1.85087C1.68645 13.6068 1.55225 13.473 1.55225 13.3086Z",
    fill: "#414142"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2075 13.3088V7.63998C18.2075 7.5354 18.293 7.44971 18.3976 7.44971H18.9919C19.0962 7.44971 19.1819 7.5354 19.1819 7.63998V13.3088C19.1819 13.4134 19.0962 13.4989 18.9919 13.4989H18.3976C18.2928 13.4989 18.2075 13.4134 18.2075 13.3088Z",
    fill: "url(#paint2_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66064 13.3093V7.64046C1.66064 7.53589 1.74633 7.4502 1.85091 7.4502H2.44518C2.54956 7.4502 2.63505 7.53589 2.63505 7.64046V13.3093C2.63505 13.4139 2.54956 13.4994 2.44518 13.4994H1.85091C1.74633 13.4994 1.66064 13.4139 1.66064 13.3093Z",
    fill: "url(#paint3_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4362 2.48424C17.1306 2.09436 16.7563 1.68659 16.3565 1.39194C16.1851 1.2651 15.8383 1.03308 15.5972 1.11698C16.2332 1.64742 16.8334 2.32837 17.1444 2.70752C17.4617 3.09382 17.9804 3.77934 18.3729 4.47063C18.482 3.93382 17.7247 2.85265 17.4362 2.48424Z",
    fill: "#FFCB0A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3502 2.55101C16.7206 1.74739 16.0368 1.19985 15.7036 1.2076C16.2993 1.72293 16.8508 2.34961 17.144 2.70768C17.4343 3.06117 17.8934 3.66518 18.2699 4.29463C18.2312 3.90913 17.8852 3.23355 17.3502 2.55101Z",
    fill: "#FEFAD6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40441 2.48424C3.70999 2.09436 4.08437 1.68659 4.48399 1.39194C4.65537 1.2651 5.00211 1.03308 5.24347 1.11698C4.60765 1.64742 4.00723 2.32837 3.69628 2.70752C3.37896 3.09382 2.86025 3.77934 2.46739 4.47063C2.35863 3.93382 3.11593 2.85265 3.40441 2.48424Z",
    fill: "#FFCB0A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48964 2.55101C4.1195 1.74739 4.80323 1.19985 5.13644 1.2076C4.54079 1.72293 3.98927 2.34961 3.69601 2.70768C3.40554 3.06117 2.94667 3.66518 2.57031 4.29463C2.60908 3.90913 2.95502 3.23355 3.48964 2.55101Z",
    fill: "#FEFAD6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.65721 39.762L1.9353 5.97441C1.91542 5.04812 3.1282 3.39972 3.69602 2.70784C4.25609 2.0249 5.75517 0.362793 6.7093 0.362793H14.1339C15.0876 0.362793 16.5867 2.0251 17.1466 2.70784C17.714 3.39953 18.9276 5.04852 18.9077 5.97441L18.1858 39.762C18.0796 44.7368 2.74966 44.7783 2.65721 39.762Z",
    fill: "#808184"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76512 39.7591L2.04342 5.97157C2.0132 4.55838 5.33503 0.470703 6.70926 0.470703H14.1339C15.5079 0.470703 18.8295 4.55918 18.7995 5.97157L18.0778 39.7591C17.9744 44.5896 2.85519 44.6304 2.76512 39.7591Z",
    fill: "url(#paint4_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1407 1.19347C14.3851 1.21971 14.8768 1.59548 15.073 1.7587C15.5977 2.19431 16.0728 2.70766 16.5051 3.23432C16.9341 3.75741 17.3391 4.31708 17.6688 4.90896C17.8004 5.14496 18.0835 5.69668 18.0781 5.95653L18.0779 5.95971L17.5968 12.3028L17.462 12.2533C12.5315 10.4361 8.31162 10.4363 3.38135 12.2533L3.24655 12.3028L2.76522 5.95951V5.95633C2.75965 5.69608 3.04277 5.14476 3.17438 4.90837C3.50402 4.31688 3.90842 3.75721 4.33806 3.23393C4.77009 2.70746 5.24546 2.19431 5.76994 1.7587C5.96617 1.59567 6.45864 1.21931 6.70259 1.19347L6.70816 1.19287H6.71392C9.18542 1.19287 11.6573 1.19287 14.129 1.19287H14.1348L14.1407 1.19347Z",
    fill: "#A6A8AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.129 1.30127C11.6573 1.30127 9.1854 1.30127 6.7139 1.30127C6.49898 1.32393 6.00015 1.70825 5.83931 1.84205C5.32477 2.26911 4.84522 2.78643 4.42174 3.30296C4.00005 3.8165 3.59228 4.38035 3.269 4.96129C3.15707 5.1621 2.86838 5.72157 2.87335 5.95438L3.34356 12.1517C8.30285 10.3242 12.5404 10.3242 17.4995 12.1517L17.9695 5.95438C17.9743 5.72197 17.686 5.1621 17.5743 4.96149C17.25 4.38075 16.8426 3.8167 16.4211 3.30296C15.9977 2.78663 15.5177 2.26931 15.0036 1.84225C14.8427 1.70825 14.3439 1.32393 14.129 1.30127Z",
    fill: "url(#paint5_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58326 17.7229C4.27569 15.8284 3.96792 14.4559 3.66055 12.5616C3.63152 12.3829 3.7369 12.2123 3.90987 12.159C8.25283 10.8122 12.5958 10.7283 16.939 12.1552C17.1089 12.2111 17.2111 12.3793 17.1825 12.556C16.8747 14.4525 16.5664 15.8266 16.2588 17.7229C16.2429 17.8219 16.1936 17.901 16.1121 17.9593C16.0304 18.0171 15.9395 18.0378 15.8407 18.0207C12.2278 17.3934 8.61448 17.3934 5.00157 18.0207C4.90296 18.0378 4.8121 18.0171 4.73039 17.9593C4.64887 17.901 4.59937 17.8219 4.58326 17.7229Z",
    fill: "url(#paint6_radial)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58345 17.7232C4.27587 15.8286 3.96831 14.4562 3.66054 12.5619C3.64364 12.4581 3.67246 12.3571 3.7333 12.2802C8.05141 10.9554 12.3695 10.8803 16.6876 12.2994C16.8576 12.3551 16.96 12.5235 16.9312 12.7001C16.6234 14.5966 16.3154 15.9708 16.0075 17.8669C15.9977 17.9272 15.9757 17.9798 15.9417 18.025C15.9087 18.0286 15.8757 18.0272 15.8409 18.021C12.2278 17.3937 8.61446 17.3937 5.00156 18.021C4.90314 18.0381 4.81208 18.0174 4.73037 17.9596C4.64905 17.9013 4.59975 17.8222 4.58345 17.7232Z",
    fill: "url(#paint7_radial)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53695 25.0136V25.2108C4.53695 27.2622 4.53695 29.3138 4.53695 31.3656V31.8793C4.53695 32.3601 4.54809 32.8408 4.55445 33.3216C4.56558 34.1612 4.57334 35.0515 4.44788 35.8821C4.35086 36.5271 4.1431 37.3023 3.57607 37.6947L3.1347 37.9999L3.12297 37.4637C3.08718 35.8153 3.05139 34.1673 3.0154 32.5193L3.01381 32.4412L3.05159 32.3732C3.16193 32.1736 3.33669 32.0302 3.53213 31.9137C3.38361 31.9219 3.24106 31.8931 3.117 31.8026L3.00169 31.7187L2.99831 31.5758C2.95079 29.3818 2.89651 27.1879 2.84919 24.9939L2.84721 24.9182L2.88299 24.8514C2.96232 24.7026 3.10348 24.6436 3.27049 24.6362C3.04384 24.5237 2.86609 24.3617 2.83806 24.1L2.83687 24.0879L2.83647 24.0758C2.76748 20.8991 2.69412 17.7226 2.62513 14.5459L2.60962 13.8325L3.1168 14.3343C3.588 14.8004 3.88483 15.8891 4.03017 16.5169C4.3435 17.8715 4.48029 19.3252 4.53636 20.7118L4.53675 20.7176V20.7233C4.53675 22.0325 4.53675 23.3413 4.53675 24.6504V25.0136H4.53695ZM17.5716 24.6366C17.7386 24.644 17.8802 24.703 17.9595 24.8518L17.9951 24.9186L17.9933 24.9943C17.9462 27.1883 17.8917 29.3822 17.8438 31.5762L17.8406 31.7191L17.7251 31.803C17.6012 31.8935 17.4587 31.9223 17.3106 31.9141C17.5058 32.0306 17.6806 32.174 17.7911 32.3736L17.8289 32.4416L17.8269 32.5197C17.7911 34.1677 17.7553 35.8157 17.7195 37.4641L17.7082 37.9999L17.267 37.6947C16.6996 37.3021 16.4924 36.5271 16.3948 35.8821C16.2697 35.0515 16.2773 34.1612 16.2884 33.3216C16.2948 32.8408 16.3059 32.3601 16.3059 31.8793V31.3656C16.3059 29.3138 16.3059 27.2622 16.3059 25.2108V24.651C16.3059 23.3419 16.3059 22.0331 16.3059 20.7239V20.7182L16.3061 20.7124C16.3624 19.3258 16.499 17.8721 16.8125 16.5175C16.9577 15.8899 17.2547 14.801 17.7255 14.3349L18.2331 13.8331L18.2174 14.5465C18.1484 17.7234 18.0746 20.8997 18.006 24.0764L18.0056 24.0885L18.0042 24.1006C17.9764 24.3621 17.7985 24.5239 17.5716 24.6366Z",
    fill: "url(#paint8_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28765 31.5696C3.23775 29.2735 3.18784 27.2845 3.13794 24.988C3.24749 24.7834 3.97933 25.1057 4.24813 25.2109C4.24813 27.2623 4.24813 29.3139 4.24813 31.3656C3.97476 31.4985 3.5143 31.7351 3.28765 31.5696Z",
    fill: "url(#paint9_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.41161 37.4576C3.37562 35.8092 3.34023 34.1612 3.30444 32.5132C3.4794 32.1967 3.98002 32.0092 4.24803 31.8794C4.24803 34.0276 4.48363 36.7154 3.41161 37.4576Z",
    fill: "url(#paint10_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5554 31.5696C17.6051 29.2735 17.655 27.2845 17.7049 24.988C17.5958 24.7834 16.8635 25.1057 16.5947 25.2109C16.5947 27.2623 16.5947 29.3139 16.5947 31.3656C16.8683 31.4985 17.3284 31.7351 17.5554 31.5696Z",
    fill: "url(#paint11_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4311 37.4576C17.4669 35.8092 17.5027 34.1612 17.5385 32.5132C17.3637 32.1967 16.8629 32.0092 16.5947 31.8794C16.5947 34.0276 16.3591 36.7154 17.4311 37.4576Z",
    fill: "url(#paint12_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7172 24.0699C17.7876 20.8221 17.8582 17.7881 17.9286 14.54C17.3441 15.1184 16.7315 17.3463 16.5947 20.7238C16.5947 22.0331 16.5947 23.3419 16.5947 24.6509C16.9224 24.5372 17.6785 24.435 17.7172 24.0699Z",
    fill: "url(#paint13_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1256 24.0699C3.05502 20.8221 2.98444 17.7881 2.91406 14.54C3.49878 15.1184 4.11114 17.3463 4.24793 20.7238C4.24793 22.0331 4.24793 23.3419 4.24793 24.6509C3.92028 24.5372 3.16477 24.435 3.1256 24.0699Z",
    fill: "url(#paint14_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23749 41.0286C3.96948 40.7801 3.93946 40.3833 3.99493 40.0407C4.05796 39.6496 4.23689 39.2504 4.45837 38.9244C4.54287 38.8009 4.63632 38.6828 4.73871 38.5736L5.02639 38.2681L5.20911 38.6458C5.44908 39.1421 6.49645 39.4538 6.98276 39.5743C8.07506 39.8453 9.29082 39.9443 10.4127 39.9513C11.5363 39.9443 12.752 39.8453 13.8443 39.5743C14.3304 39.454 15.3782 39.1421 15.618 38.6458L15.8007 38.2681L16.0882 38.5736C16.191 38.6828 16.2842 38.8009 16.3683 38.9244C16.5902 39.2506 16.7689 39.6496 16.8322 40.0407C16.8874 40.3833 16.8578 40.7801 16.5896 41.0286C16.023 41.775 14.9722 42.2068 14.0996 42.4526C12.9272 42.7826 11.6367 42.912 10.4203 42.913H10.405C9.18963 42.9118 7.8997 42.7822 6.72747 42.4526C5.85487 42.2068 4.80392 41.775 4.23749 41.0286Z",
    fill: "#DBDCDD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4139 40.2401C7.90836 40.2245 5.40665 39.7166 4.94957 38.771C4.34099 39.4179 4.0362 40.4838 4.45113 40.8321C5.3305 42.0242 7.86701 42.6215 10.4061 42.6243H10.4139H10.4216C12.9611 42.6215 15.4968 42.0242 16.3764 40.8321C16.7917 40.4838 16.4865 39.4179 15.8779 38.771C15.4209 39.7166 12.9192 40.2245 10.4139 40.2401Z",
    fill: "url(#paint15_radial)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.349179 15.6783C0.270845 15.453 0.240028 15.2061 0.366874 14.9921C0.524138 14.7269 0.878629 14.5989 1.15836 14.514C1.53572 14.3991 1.92162 14.3209 2.29639 14.1927C2.43219 14.1466 2.56579 14.0941 2.69542 14.0319L2.78906 13.9863L2.8163 14.0869C2.89324 14.3742 2.96999 14.6615 3.04693 14.9486L3.0692 15.0321L2.98589 15.0544C2.14171 15.2806 1.29714 15.5067 0.45316 15.7329L0.375423 15.7536L0.349179 15.6783Z",
    fill: "#A6A8AC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.431041 15.6506C0.0322143 14.5042 1.60207 14.6555 2.73314 14.1104C2.81009 14.3976 2.88683 14.6849 2.96397 14.9718C2.1194 15.1981 1.27542 15.4243 0.431041 15.6506Z",
    fill: "#F2F2F2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82326 15.0987L2.54932 14.0767L2.20346 14.1694L2.4774 15.1914L2.82326 15.0987Z",
    fill: "#A6A8AC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71769 15.0381L2.48853 14.1831L2.30955 14.2311L2.53871 15.086L2.71769 15.0381Z",
    fill: "#D1D2D3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4939 15.6783C20.5722 15.453 20.6026 15.2061 20.4758 14.9921C20.3191 14.7269 19.9642 14.5989 19.6847 14.514C19.3073 14.3991 18.9212 14.3209 18.5468 14.1927C18.4108 14.1466 18.2768 14.0941 18.148 14.0319L18.0536 13.9863L18.0267 14.0869C17.9496 14.3742 17.873 14.6615 17.7959 14.9486L17.7734 15.0321L17.8567 15.0544C18.7015 15.2806 19.5457 15.5067 20.3901 15.7329L20.4674 15.7536L20.4939 15.6783Z",
    fill: "#A6A8AC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4124 15.6501C20.811 14.5037 19.2413 14.655 18.1103 14.1099C18.0333 14.3972 17.9566 14.6844 17.8796 14.9713C18.7236 15.1976 19.568 15.4238 20.4124 15.6501Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3668 15.1904L18.6401 14.1685L18.2948 14.0761L18.0215 15.098L18.3668 15.1904Z",
    fill: "#A6A8AC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3031 15.0859L18.5325 14.231L18.3533 14.1829L18.124 15.0378L18.3031 15.0859Z",
    fill: "#D1D2D3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67715 23.5857C2.67536 23.4428 2.64335 22.8438 2.77239 22.8438H2.89128L2.91355 23.9798C2.7529 23.9959 2.67994 23.7742 2.67715 23.5857Z",
    fill: "#929497"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88026 23.9261C2.74586 23.9393 2.71167 23.6858 2.71027 23.5856C2.70829 23.4446 2.68801 22.8867 2.7737 22.8867C2.79398 22.8867 2.80988 22.8867 2.85998 22.8867C2.86694 23.2376 2.8735 23.5752 2.88026 23.9261Z",
    fill: "url(#paint16_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.82495 31.1233C2.82296 30.9804 2.79115 30.3813 2.92018 30.3813H3.03927L3.06134 31.5176C2.9005 31.5335 2.82733 31.3118 2.82495 31.1233Z",
    fill: "#929497"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0281 31.4645C2.8935 31.478 2.85911 31.2245 2.85811 31.1243C2.85593 30.9834 2.83565 30.4253 2.92154 30.4253C2.94162 30.4253 2.95772 30.4253 3.00782 30.4253C3.01458 30.7764 3.02114 31.114 3.0281 31.4645Z",
    fill: "url(#paint17_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1654 23.5852C18.1672 23.4423 18.1992 22.8433 18.0702 22.8433H17.9515L17.9294 23.9793C18.0897 23.9954 18.1629 23.7737 18.1654 23.5852Z",
    fill: "#929497"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9619 23.9266C18.0967 23.9397 18.1311 23.6863 18.1323 23.586C18.1343 23.4451 18.1548 22.8872 18.0689 22.8872C18.0484 22.8872 18.0323 22.8872 17.9822 22.8872C17.9756 23.2381 17.9689 23.5757 17.9619 23.9266Z",
    fill: "url(#paint18_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0181 31.1238C18.0199 30.9809 18.0519 30.3818 17.9229 30.3818H17.8042L17.7817 31.5181C17.9424 31.534 18.0153 31.3123 18.0181 31.1238Z",
    fill: "#929497"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8154 31.4655C17.9498 31.479 17.9844 31.2255 17.9856 31.1253C17.9876 30.9843 18.0079 30.4263 17.9222 30.4263C17.9019 30.4263 17.8858 30.4263 17.8357 30.4263C17.8289 30.7774 17.8224 31.115 17.8154 31.4655Z",
    fill: "url(#paint19_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.87981 38.4855C4.80088 31.8597 4.9319 21.6258 4.64282 18.3992C8.46369 17.6912 12.3798 17.6912 16.2007 18.3992C15.9112 21.6258 16.0424 31.8597 15.9639 38.4855C15.9824 40.9154 4.86073 40.9154 4.87981 38.4855Z",
    fill: "url(#paint20_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51622 37.573C5.60668 32.3093 5.45896 27.0426 5.05318 21.7947C5.04383 21.6744 5.07286 21.5593 5.16511 21.4781C5.30409 21.3563 5.50429 21.3702 5.67468 21.3702C5.89696 21.3702 6.09935 21.5573 6.09041 21.7903C5.88503 27.05 6.08464 32.3244 6.55325 37.5646C6.56419 37.6839 6.53695 37.7981 6.44669 37.8796C6.30791 38.0046 6.10373 37.9903 5.93215 37.9903C5.70927 37.9903 5.52278 37.8054 5.51622 37.578V37.5752V37.573ZM15.3269 37.578C15.3203 37.8056 15.1338 37.9903 14.9109 37.9903C14.8304 37.9903 14.7533 37.9943 14.6727 37.9857C14.434 37.9609 14.2658 37.8324 14.2896 37.5648C14.7584 32.3246 14.958 27.05 14.7529 21.7905C14.7437 21.5575 14.9461 21.3704 15.1686 21.3704C15.2487 21.3704 15.3259 21.3668 15.4062 21.3752C15.6436 21.4002 15.8104 21.5294 15.7899 21.7947C15.3839 27.0426 15.2366 32.3093 15.3271 37.573V37.5754L15.3269 37.578Z",
    fill: "#BBBDBF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62447 37.5797C5.71453 32.4027 5.568 27.2257 5.16102 22.0487C5.13458 21.7129 5.5014 21.7487 5.67457 21.7487C5.83859 21.7487 5.9887 21.8841 5.98194 22.0487C5.78034 27.1304 5.96663 32.316 6.44558 37.5797C6.476 37.9155 6.10481 37.8799 5.93204 37.8799C5.76742 37.8799 5.62944 37.7447 5.62447 37.5797ZM15.2188 37.5797C15.1281 32.4027 15.2749 27.2257 15.682 22.0487C15.7085 21.7129 15.3417 21.7487 15.1687 21.7487C15.0045 21.7487 14.8546 21.8841 14.8609 22.0487C15.0629 27.1304 14.8762 32.316 14.3977 37.5797C14.3671 37.9155 14.738 37.8799 14.911 37.8799C15.0754 37.8799 15.2136 37.7447 15.2188 37.5797Z",
    fill: "#F2F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60815 2.71631C6.79206 3.8599 6.96185 5.19297 7.09665 6.61651C7.23164 8.04043 7.31455 9.3735 7.34736 10.5169C7.16365 9.3735 6.99406 8.04043 6.85926 6.61651C6.72446 5.19297 6.64136 3.8599 6.60815 2.71631ZM14.2342 2.71631C14.0507 3.8599 13.8809 5.19297 13.7459 6.61651C13.6109 8.04043 13.5284 9.3735 13.4954 10.5169C13.6793 9.3735 13.8483 8.04043 13.9833 6.61651C14.1183 5.19297 14.2014 3.8599 14.2342 2.71631Z",
    fill: "#DBDCDD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1639 25.5946C10.1639 25.7619 10.1194 25.9107 10.0304 26.0412C9.94291 26.1716 9.82397 26.2736 9.67358 26.3473C9.84853 26.4225 9.98664 26.5322 10.0879 26.6765C10.1907 26.8207 10.2422 26.9842 10.2422 27.1668C10.2422 27.4568 10.1439 27.6878 9.94751 27.8597C9.75262 28.0315 9.49557 28.1175 9.17637 28.1175C8.85411 28.1175 8.59553 28.0315 8.40063 27.8597C8.20728 27.6862 8.1106 27.4553 8.1106 27.1668C8.1106 26.9857 8.1597 26.8223 8.25792 26.6765C8.35767 26.5307 8.49501 26.4202 8.66996 26.345C8.5211 26.2713 8.4037 26.1693 8.31777 26.0389C8.23183 25.9084 8.18886 25.7603 8.18886 25.5946C8.18886 25.3122 8.2794 25.0882 8.46048 24.9224C8.64157 24.7567 8.8802 24.6738 9.17637 24.6738C9.47102 24.6738 9.70888 24.7567 9.88996 24.9224C10.0726 25.0882 10.1639 25.3122 10.1639 25.5946ZM9.8163 27.1576C9.8163 26.9704 9.75645 26.8177 9.63675 26.6995C9.51859 26.5813 9.3636 26.5223 9.17177 26.5223C8.97995 26.5223 8.82572 26.5806 8.70909 26.6972C8.59399 26.8138 8.53645 26.9673 8.53645 27.1576C8.53645 27.3479 8.59246 27.4975 8.70449 27.6064C8.81805 27.7154 8.97534 27.7699 9.17637 27.7699C9.37587 27.7699 9.5324 27.7154 9.64596 27.6064C9.75952 27.496 9.8163 27.3463 9.8163 27.1576ZM9.17637 25.0237C9.0091 25.0237 8.87329 25.0759 8.76894 25.1802C8.66612 25.2831 8.61471 25.4235 8.61471 25.6015C8.61471 25.7718 8.66535 25.9099 8.76664 26.0158C8.86945 26.1202 9.00603 26.1724 9.17637 26.1724C9.34671 26.1724 9.48253 26.1202 9.58381 26.0158C9.68663 25.9099 9.73804 25.7718 9.73804 25.6015C9.73804 25.4312 9.68509 25.2923 9.57921 25.1848C9.47332 25.0774 9.33904 25.0237 9.17637 25.0237Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8801 26.642C12.8801 27.1407 12.795 27.5113 12.6246 27.7538C12.4543 27.9962 12.188 28.1175 11.8259 28.1175C11.4683 28.1175 11.2036 27.9993 11.0317 27.763C10.8598 27.5251 10.7708 27.1706 10.7647 26.6995V26.1309C10.7647 25.6383 10.8499 25.2723 11.0202 25.0329C11.1905 24.7935 11.4576 24.6738 11.8213 24.6738C12.1819 24.6738 12.4474 24.7897 12.6177 25.0214C12.7881 25.2516 12.8755 25.6076 12.8801 26.0895V26.642ZM12.4543 26.0596C12.4543 25.6989 12.4036 25.4365 12.3024 25.2723C12.2011 25.1066 12.0407 25.0237 11.8213 25.0237C11.6033 25.0237 11.4445 25.1058 11.3448 25.27C11.245 25.4342 11.1936 25.6867 11.1905 26.0273V26.7087C11.1905 27.0709 11.2427 27.3387 11.3471 27.5121C11.453 27.6839 11.6125 27.7699 11.8259 27.7699C12.0361 27.7699 12.1919 27.6885 12.2931 27.5259C12.396 27.3632 12.4497 27.1069 12.4543 26.757V26.0596Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.5C15 28.9853 12.9853 31 10.5 31C8.01472 31 6 28.9853 6 26.5C6 24.0147 8.01472 22 10.5 22C12.9853 22 15 24.0147 15 26.5Z",
    stroke: "#F9A825",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.2345,
    y1: 32.7906,
    x2: 18.2345,
    y2: 38.2434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 2.60864,
    y1: 32.7916,
    x2: 2.60864,
    y2: 38.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.6948,
    y1: 7.44967,
    x2: 18.6948,
    y2: 12.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2.14791,
    y1: 7.45016,
    x2: 2.14791,
    y2: 12.9033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A6A8AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 18.7996,
    y1: 21.9341,
    x2: 2.04332,
    y2: 21.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 17.9696,
    y1: 6.72641,
    x2: 2.87331,
    y2: 6.72641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.88044 21.4815) scale(9.38425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB1B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.89753 21.4099) scale(10.6216)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 10.4216,
    y1: 26.5787,
    x2: 10.4216,
    y2: 10.0375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 4.02608,
    y1: 28.2737,
    x2: 3.35988,
    y2: 28.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 4.1046,
    y1: 34.6685,
    x2: 3.49219,
    y2: 34.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808184"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 17.4829,
    y1: 28.2737,
    x2: 16.8167,
    y2: 28.2737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 17.3454,
    y1: 34.6685,
    x2: 16.7659,
    y2: 34.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 17.6619,
    y1: 19.5955,
    x2: 16.8615,
    y2: 19.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 3.98121,
    y1: 19.5955,
    x2: 3.18076,
    y2: 19.5955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41403B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B83"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.2906 36.8444) scale(7.50852)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 2.79823,
    y1: 23.9341,
    x2: 2.77976,
    y2: 22.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 2.94611,
    y1: 31.4721,
    x2: 2.92764,
    y2: 30.4147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 18.0627,
    y1: 22.8764,
    x2: 18.0443,
    y2: 23.9344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 17.916,
    y1: 30.4156,
    x2: 17.8976,
    y2: 31.4733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D2D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 16.2005,
    y1: 29.088,
    x2: 4.64276,
    y2: 29.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBBDBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.939fac64e1a21fc3235129d0d2401534.svg";
export { ForwardRef as ReactComponent };